export const LANGUAGE_BUILDER_EN = {
  // useLanguageManagement.ts (toasts and thrown errors)
  lbToastLoadFailed: 'Failed to load languages',
  lbToastNameEmpty: 'Language name cannot be empty',
  lbToastNameExists: 'A language with this name already exists',
  lbToastNameTooLong: 'Language name must be 20 characters or fewer',
  lbToastNoCustomization: 'No customization loaded',
  lbToastSaveSuccess: 'Languages saved successfully',
  lbToastSaveFailed: 'Failed to save languages',
  lbToastRemoveSuccess: 'Language "{name}" removed',
  lbToastGenerateFailed: 'Failed to generate language descriptor',
  lbToastUpdateFailed: 'Failed to update language descriptor',
  lbToastNoOutput: 'No language descriptor generated',

  // CreationDialog + generation lifecycle
  lbAddNewLanguage: 'Add New Language',
  lbAddNewLanguageDesc:
    'Enter a name and describe the language. Languages can capture base languages, dialects, or mixed-language speech (e.g. Denglish).',
  lbGeneratingLanguage: 'Generating Language',

  // LanguageBuilder.vue + LanguageSidebarGroup.vue
  currentLanguages: 'Current Languages',
  recommendedLanguages: 'Recommended Languages',
  recommendedLanguagesHint:
    'Common starting points for guidance — add one and tailor it to match your speakers.',
  noLanguagesConfigured: 'No languages configured',
  languageContent: 'Language Descriptor',
  describeYourLanguage: 'Describe the language, dialect, or mixed speech you want...',
  removeLanguageTitle: 'Remove language',
  languageBuilderDescriptorPlaceholder:
    'e.g. German base with English vocabulary and phrases mixed in (Denglish)',

  // LanguagePreview.vue (language-specific copy; shared chrome lives in BUILDERS_COMMON)
  languagePreviewEmptyHint: 'Click Regenerate to see how this language sounds.',
  languagePreviewUnavailable:
    'Preview is unavailable in this environment. Ask an admin to set up the LANGUAGE PREVIEW prompt.',
  languagePreviewErrorEmptyLanguage:
    'Add some language descriptor content before generating a preview.',

  // Admin-managed (legacy-locked) banner
  lbAdminManagedLanguage: 'Admin Managed Language',
  lbAdminManagedDesc:
    "This language is managed by your administrator and can't be edited from this page.",
  lbAdminManagedHint: 'Contact your admin if you need changes to this language.',
  lbLockForOrgAdmins: 'Lock for organisation admins',
  lbUnlockForOrgAdmins: 'Unlock for organisation admins'
}

export const LANGUAGE_BUILDER_DE = {
  // useLanguageManagement.ts (toasts and thrown errors)
  lbToastLoadFailed: 'Sprachen konnten nicht geladen werden',
  lbToastNameEmpty: 'Sprachname darf nicht leer sein',
  lbToastNameExists: 'Eine Sprache mit diesem Namen existiert bereits',
  lbToastNameTooLong: 'Sprachname darf höchstens 20 Zeichen lang sein',
  lbToastNoCustomization: 'Keine Anpassung geladen',
  lbToastSaveSuccess: 'Sprachen erfolgreich gespeichert',
  lbToastSaveFailed: 'Sprachen konnten nicht gespeichert werden',
  lbToastRemoveSuccess: 'Sprache "{name}" entfernt',
  lbToastGenerateFailed: 'Sprachbeschreibung konnte nicht generiert werden',
  lbToastUpdateFailed: 'Sprachbeschreibung konnte nicht aktualisiert werden',
  lbToastNoOutput: 'Keine Sprachbeschreibung generiert',

  // CreationDialog + generation lifecycle
  lbAddNewLanguage: 'Neue Sprache hinzufügen',
  lbAddNewLanguageDesc:
    'Gib einen Namen ein und beschreibe die Sprache. Sprachen können Basis-Sprachen, Dialekte oder gemischte Sprachstile (z. B. Denglisch) abbilden.',
  lbGeneratingLanguage: 'Sprache wird erstellt',

  // LanguageBuilder.vue + LanguageSidebarGroup.vue
  currentLanguages: 'Aktuelle Sprachen',
  recommendedLanguages: 'Empfohlene Sprachen',
  recommendedLanguagesHint:
    'Gängige Ausgangspunkte zur Orientierung – fügen Sie eine hinzu und passen Sie sie an Ihre Sprechergruppe an.',
  noLanguagesConfigured: 'Keine Sprachen konfiguriert',
  languageContent: 'Sprachbeschreibung',
  describeYourLanguage: 'Beschreibe die Sprache, den Dialekt oder die Mischsprache...',
  removeLanguageTitle: 'Sprache entfernen',
  languageBuilderDescriptorPlaceholder:
    'z. B. Deutsch als Basis mit eingestreutem englischen Vokabular (Denglisch)',

  // LanguagePreview.vue (language-specific copy; shared chrome lives in BUILDERS_COMMON)
  languagePreviewEmptyHint: 'Klicke auf Neu generieren, um zu sehen, wie diese Sprache klingt.',
  languagePreviewUnavailable:
    'Vorschau ist in dieser Umgebung nicht verfügbar. Bitte einen Admin, den LANGUAGE PREVIEW-Prompt einzurichten.',
  languagePreviewErrorEmptyLanguage:
    'Füge eine Sprachbeschreibung hinzu, bevor du eine Vorschau generierst.',

  // Admin-managed (legacy-locked) banner
  lbAdminManagedLanguage: 'Admin-verwaltete Sprache',
  lbAdminManagedDesc:
    'Diese Sprache wird von deinem Administrator verwaltet und kann hier nicht bearbeitet werden.',
  lbAdminManagedHint: 'Wende dich an deinen Administrator, wenn du Änderungen brauchst.',
  lbLockForOrgAdmins: 'Für Organisations-Admins sperren',
  lbUnlockForOrgAdmins: 'Für Organisations-Admins entsperren'
}
